import { Box, Inline, Stack } from "@sembark-travel/ui-base"

/**
 * One chat bubble, as a WhatsApp conversation draws it: the customer's on the
 * left, ours on the right in the send colour. Whatever sits under the bubble —
 * reactions, the sender's name — goes in `below`. A `muted` bubble is one
 * the customer no longer sees, such as a message deleted for everyone.
 */
export function WhatsAppMessageBubble({
	inbound,
	children,
	below,
	muted = false,
}: {
	inbound: boolean
	children: React.ReactNode
	below?: React.ReactNode
	muted?: boolean
}) {
	return (
		<Inline justifyContent={inbound ? "start" : "end"}>
			<Stack
				gap="px"
				alignItems={inbound ? "start" : "end"}
				style={{ maxWidth: "80%" }}
			>
				<Box
					paddingX="3"
					paddingY="2"
					rounded="md"
					borderWidth="1"
					bgColor={inbound ? "default" : "success"}
					borderColor={inbound ? "default" : "success"}
					maxWidth="full"
					style={muted ? { opacity: 0.55 } : undefined}
				>
					<Stack gap="2">{children}</Stack>
				</Box>
				{below}
			</Stack>
		</Inline>
	)
}
